import { StyleSheet } from 'react-native';

import { spacing } from '../theme';

export const typeaheadSearchStyles = StyleSheet.create({
	label: {
		marginBottom: spacing.s,
		fontSize: 16,
	},
	flex: {
		flex: 1,
	},
	container: {
		flex: 1,
		padding: 10,
	},
	smallScreenField: {
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
		width: '100%',
		minHeight: 48,
		paddingHorizontal: 12,
		borderWidth: 1,
		borderRadius: 8,
	},
	desktopMenu: {
		maxWidth: 400,
		width: '100%',
	},
	modalContainer: {
		position: 'absolute',
		top: 0,
		left: 0,
		width: '100%',
		height: '100%',
		padding: 0,
		margin: 0,
		textAlign: 'left',
	},
	modalHeader: {
		paddingHorizontal: 10,
		paddingTop: 10, // Add some padding top
		paddingBottom: 5,
		borderBottomWidth: StyleSheet.hairlineWidth,
		borderBottomColor: '#ccc',
	},
	modalSearchbar: {
		width: 'auto',
		marginHorizontal: 10,
		marginTop: 10,
		marginBottom: 5,
	},
	modalList: {
		flex: 1,
		width: '100%',
	},
	modalOptionItem: {
		paddingVertical: 12,
		paddingHorizontal: 16,
		height: 50,
		width: '100%',
	},
	modalEmptyState: {
		flex: 1,
		alignItems: 'center',
		justifyContent: 'center',
		padding: 20,
	},
	menuContainer: {
		position: 'absolute',
		top: 60, // Position below the input field
		left: 0,
		right: 0,
		maxHeight: 300, // Set a max height for the menu
		alignItems: 'flex-start',
		justifyContent: 'flex-start',
		padding: 0,
		backgroundColor: 'white',
		borderRadius: 4,
		borderWidth: 1,
		borderColor: '#ccc',
		zIndex: 100, // Ensure it appears above other content
		overflow: 'scroll', // Allow scrolling if content exceeds maxHeight
		shadowColor: '#000',
		shadowOffset: { width: 0, height: 2 },
		shadowOpacity: 0.1,
		shadowRadius: 4,
		elevation: 100,
	},
	menuItem: {
		padding: 12,
		width: '100%',
		borderBottomWidth: StyleSheet.hairlineWidth,
		borderBottomColor: '#ccc',
	},
});
